import './styles/styles.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ErrorBoundary } from 'components/organisms/errorBoundary/ErrorBoundary';
import App from './App';

async function enableMocking() {
  if (process.env.REACT_APP_ENV !== 'development' && process.env.REACT_APP_ENABLE_MSW !== '1') {
    return Promise.resolve();
  }
  const { worker } = await import('./mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocking().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
